"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _alert = _interopRequireDefault(require("../../../../../core/alert"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _setApplicationOwner = _interopRequireDefault(require("./setApplicationOwner"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  contactName: null,
  contactEmail: null,
  isProcessing: false,
  errorMessage: null
};
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to change ownership");
class ApplicationOwner extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_setValue", (value, field) => {
      this.setState({
        [field]: value
      });
    });
    _defineProperty(this, "_getValue", field => {
      return this.state[field] || this.props.applicationByID[field];
    });
    _defineProperty(this, "_getApplication", () => {
      return {
        ...this.props.applicationByID,
        contactName: this._getValue('contactName'),
        contactEmail: this._getValue('contactEmail')
      };
    });
    _defineProperty(this, "_clearError", () => {
      this.setState({
        errorMessage: null
      });
    });
    _defineProperty(this, "_onConfirm", () => {
      if (this.state.isProcessing) return;
      this.setState({
        isProcessing: true
      });
      return this.props.changeOwner(this.props.applicationID, this.state.contactName || this.props.applicationByID.contactName, this.state.contactEmail).then(res => {
        if (res.errorMessage) return this.setState({
          errorMessage: res.errorMessage,
          isProcessing: false
        });
        this.setState(initialState);
        this._onCloseCancel();
      });
    });
    _defineProperty(this, "_onCloseCancel", () => {
      this.props.onToggleChangeOwner();
    });
    _defineProperty(this, "_canConfirm", () => {
      if (!this.state.contactEmail) return false;
      return this.state.contactEmail !== this.props.applicationByID.contactEmail;
    });
    _defineProperty(this, "_getModalButtons", () => {
      if (this.state.errorMessage) return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._clearError
      }, "OK"));
      return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onCloseCancel
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onConfirm,
        type: "primary",
        disabled: !this._canConfirm()
      }, "Confirm New Owner"));
    });
  }
  render() {
    const application = this.props.applicationByID;
    if (!application || !application.id) return null;
    if (!this.props.userIsCalendarOfficer) return _ref;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: application.calendarDateID + ' - ' + application.competitionName,
      onClose: this._onCloseCancel,
      size: "lg",
      buttons: this._getModalButtons()
    }, this.state.errorMessage ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.errorMessage) : /*#__PURE__*/_react.default.createElement(_setApplicationOwner.default, {
      setValue: this._setValue,
      application: this._getApplication(),
      userIsCalendarOfficer: this.props.userIsCalendarOfficer
    })));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref2 = {
  id: true,
  calendarID: true,
  contactName: true,
  contactEmail: true,
  calendarDateID: true,
  competitionName: true
};
var _default = exports.default = (0, _reactBicycle.connect)(ApplicationOwner, props => ({
  userIsCalendarOfficer: true,
  ["applicationByID(applicationID:" + JSON.stringify(props.applicationID) + ")"]: _ref2
}), (client, props) => ({
  changeOwner(applicationID, contactName, contactEmail) {
    return client.update('Application.changeOwner', {
      applicationID,
      contactName,
      contactEmail
    });
  }
}));